<template>
  <div>
    <v-data-table
      :headers="tablazatok.sablonbejegyzesek.fejlec"
      :items="sablonbejegyzesektablazata"
      >
      <template v-slot:top>
        <v-row>
          <v-col cols=12 sm="3"><h2>{{adatok.sablon.nev}}</h2></v-col>
          <v-col cols="12" sm="3"><v-btn rounded color="success" @click="dialogusok.bejegyzeshozzaadasa.mutat=true"><v-icon>fa-plus</v-icon>Bejegyzés hozzáadása</v-btn></v-col>
          <v-col cols="12" sm="3"><v-checkbox v-model="adatok.sablon.diakmodosithatja" readonly @click="diakmodosithatjavaltozas()" label="A sablon alkalmazása esetén a jelöléseket a diákok módosíthatják"/></v-col>
          <v-col cols="12" sm="3"><v-checkbox v-model="dialogusok.torles.megerositesnelkul"  label="Bejegyzések törlése a sablonból megerősítés nélkül"/></v-col>

        </v-row>
      </template>
      <template v-slot:item.muveletek="{item}">
        <!--<v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn icon v-bind="attrs" v-on="on" color="info" :to="{name: 'szilenciumibejegyzessablon', params: {id: item.id}}"><v-icon>fa-edit</v-icon></v-btn>
          </template>
          Szerkesztés
        </v-tooltip>-->
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn  icon v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(item)"><v-icon>fa-trash</v-icon></v-btn>
          </template>
          Törlés
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
        v-model="dialogusok.bejegyzeshozzaadasa.mutat"
        persistent
        max-width="600px"
    >

        <v-card>
          <v-card-title>
            <span class="headline" >Bejegyzés hozzáadása a sablonhoz</span>
          </v-card-title>
          <v-card-text>
            <p>Csak olyan tanuló kerül bele a listába, aki szilenciumjelölésre kötelezett</p>

            <v-container >
              <v-select
                rounded
                outlined
                prepend-inner-icon="fa-business-time"
                label="Szilencium"
                v-model="dialogusok.bejegyzeshozzaadasa.adatok.szilencium"
                @change="dialogusok.bejegyzeshozzaadasa.adatok.terem=null"
                :items="adatok.szilenciumok.map(sz => {
                  return {
                    text: `${sz.szam}. (${sz.idopont})`,
                    value: sz.id
                  }
                })"/>
              <v-select
                v-if="dialogusok.bejegyzeshozzaadasa.adatok.szilencium!=null"
                rounded
                outlined
                prepend-inner-icon="fa-chalkboard-teacher"
                label="Terem"
                :items="adatok.termek.filter(t => adatok['terem-szilencium'].findIndex(tsz => tsz.szilenciumid==dialogusok.bejegyzeshozzaadasa.adatok.szilencium&&tsz.teremid==t.id)!=-1)"
                item-value="id"
                item-text="nev"
                @change="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg=null"
                v-model="dialogusok.bejegyzeshozzaadasa.adatok.terem"
                />
                <v-select
                  v-if="dialogusok.bejegyzeshozzaadasa.adatok.terem!=null"
                  rounded
                  outlined
                  prepend-inner-icon="fa-atom"
                  label="Diákok választási szempontja"
                  :items="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.lehetosegek"
                  @change="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok1=[], dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok2=[]"
                  v-model="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg"
                  />
                <v-select
                  v-if="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg!=null&&dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg!=2"
                  rounded
                  outlined
                  :items="szempontlehetosegek1"
                  v-model="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok1"
                  multiple
                  :prepend-inner-icon="(() => {
                    switch(dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg){
                      case 0:return 'fa-user';break;
                      case 1:return 'fa-users';break;
                      case 13:;
                      case 3:return 'fa-star';break;

                    }
                    })()"
                  :label="(() => {
                    switch(dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg){
                      case 0:return 'Tanuló(k)';break;
                      case 1:return 'Csoport(ok)';break;
                      case 13:;
                      case 3:return 'Minősítés(ek)';break;

                    }
                    })()"/>
                    <v-select
                      v-if="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg==13"
                      rounded
                      outlined
                      :items="szempontlehetosegek2"
                      v-model="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok2"
                      multiple
                      :prepend-inner-icon="(() => {
                        switch(dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg){
                          case 13:return 'fa-users';break;

                        }
                        })()"
                      :label="(() => {
                        switch(dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg){
                          case 13:return 'Csoport(ok)';break;


                        }
                        })()"/>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialogusok.bejegyzeshozzaadasa.mutat=false"
            >
              Mégsem<v-icon>fa-times</v-icon>
            </v-btn>
            <v-btn
              color="success"
              text
              v-if="dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg==2?true:dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok1.length>0&&(dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg==13?dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok2.length>0:true)"
              @click="hozzaadas"
            >
              Hozzáadás<v-icon>fa-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogusok.torles.mutat"
        persistent
        max-width="600px"
    >

        <v-card>
          <v-card-title>
            <span class="headline" >Bejegyzés törlése</span>
          </v-card-title>
          <v-card-text>
            <p>Biztosan szeretné törölni az alábbi bejegyzést?</p>
            <p>{{dialogusok.torles.bejegyzes.tanulo}}  (Csop: {{dialogusok.torles.bejegyzes.csoport}}, szoba: {{dialogusok.torles.bejegyzes.szoba}}, {{dialogusok.torles.bejegyzes.minosites}}) - {{dialogusok.torles.bejegyzes.szilencium}} ({{dialogusok.torles.bejegyzes.terem}})</p>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialogusok.torles.mutat=false"
            >
              Mégsem<v-icon>fa-times</v-icon>
            </v-btn>
            <v-btn
              color="red accent-4"
              text
              @click="torles"
            >
              Törlés<v-icon>fa-trash</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <template>
  		<v-snackbar
  		 v-model="snackbar.megnyit"
  		>
  		 {{ snackbar.szoveg }}
  		 <v-btn
  			 color="pink"
  			 text
  			 @click="snackbar.megnyit = false"
  		 >
  			 Bezár
  		 </v-btn>
  		</v-snackbar>
	</template>
  </div>
</template>


<script>
	import router from '../router';
	export default {
		data: function(){
			return {
        snackbar: {
          megnyit: false,
          szoveg: ""
        },
        tablazatok: {
          sablonbejegyzesek: {
            fejlec: [
              {
                text: "Csoport",
                value: "csoport",
                align: "center",
                sortable: true,
                groupable: false,
                filterable: false
              },
              {
                text: "Tanuló",
                value: "tanulo",
                align: "center",
                sortable: true,
                groupable: false,
                filterable: false
              },
              {
                text: "Szilencium",
                value: "szilencium",
                align: "center",
                sortable: true,
                groupable: true,
                filterable: false
              },
              {
                text: "Terem",
                value: "terem",
                align: "center",
                sortable: true,
                groupable: true,
                filterable: false
              },
              {
                text: "Minősítés",
                value: "minosites",
                align: "center",
                sortable: true,
                groupable: false,
                filterable: false
              },
              {
                text: "Szoba",
                value: "szoba",
                align: "center",
                sortable: true,
                groupable: false,
                filterable: false
              },
              {
                text: "Műveletek",
                value: "muveletek",
                align: "center",
                sortable: false,
                groupable: false,
                filterable: false
              }
            ]
          }
        },
        dialogusok: {
          torles: {
            mutat: false,
            megerositesnelkul: false,
            bejegyzes: {}
          },
          bejegyzeshozzaadasa: {
            mutat: false,
            diakokvalasztasa: {
              kivalasztottszempontok1: [],
              kivalasztottszempontok2: [],
              valasztottlehetoseg: null,
              lehetosegek: [
                {
                  text: "Tanuló(k)",
                  value: 0
                },
                {
                  text: "Csoport(ok)",
                  value: 1
                },
                {
                  text: "Teljes kollégium",
                  value: 2
                },
                {
                  text: "Adott minősítés(ek) teljes kollégiumra",
                  value: 3
                },
                {
                  text: "Adott minősítés(ek) adott csoport(ok)ra",
                  value: 13
                }
              ]
            },
            adatok: {
              szilencium: null,
              terem: null
            }
          }

        },
        adatok: {}
      }
		},
		computed: {
      szempontlehetosegek1() {
        switch(this.dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg) {
          case 0:
            return this.adatok.felhasznalok.filter(f => f.minosites>=0&&this.adatok.minositesek.find(m => m.id==f.minosites).szilenciumvalasztas==1 && this.adatok.sablonbejegyzesek.findIndex(sb => sb.tanuloid==f.id && sb.szilenciumid==this.dialogusok.bejegyzeshozzaadasa.adatok.szilencium)==-1).map(f => {
              return {
                text: f.nev,
                value: f.id
              }
            })
          break;
          case 1:
            return this.adatok.csoportok.map(cs => {
              return {
                text: `${cs.csoportnev} - ${this.adatok.felhasznalok.find(f => f.id == cs.csoportvezetoid).nev}`,
                value: cs.id
              }
            })
          break;
          case 13:
          case 3:
            return this.adatok.minositesek.filter(m => m.szilenciumvalasztas==1).map(m => {
              return {
                text: m.minositesnev,
                value: m.id
              }
            })
          break;
        }
      },
      szempontlehetosegek2() {
        switch(this.dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg) {
          case 13:
            return this.adatok.csoportok.map(cs => {
              return {
                text: `${cs.csoportnev} - ${this.adatok.felhasznalok.find(f => f.id == cs.csoportvezetoid).nev}`,
                value: cs.id
              }
            })
          break;
        }
      },
      sablonbejegyzesektablazata() {
        if(this.adatok.sablonbejegyzesek){
          const csoportok = this.adatok.csoportok.map(cs => {
            return {
              id: cs.id,
              nev: cs.csoportnev,
              csoportvezeto: this.adatok.felhasznalok.find(csv => csv.id==cs.csoportvezetoid).nev
            }
          })
          return this.adatok.sablonbejegyzesek.map(sb => {
            const tanulo = this.adatok.felhasznalok.find(t => t.id==sb.tanuloid)
            const szilo = this.adatok.szilenciumok.find(sz => sz.id==sb.szilenciumid)
            const csoport = tanulo.csoportid? csoportok.find(cs => cs.id==tanulo.csoportid) : null
            return {
              bejegyzes: {...sb},
              tanulo: tanulo.nev,
              minosites: this.adatok.minositesek.find(m => m.id==tanulo.minosites).minositesnev,
              csoport: csoport ? `${csoport.nev} - ${csoport.csoportvezeto}` : "-",
              szoba: tanulo.szobaid?this.adatok.szobak.find(sz => sz.id==tanulo.szobaid).szobanev:"-",
              szilencium: `${szilo.szam}. (${szilo.idopont})`,
              terem: sb.teremid?this.adatok.termek.find(t => t.id==sb.teremid).nev:null
            }
          })
        } else return []
      }
		},
		watch: {

		},
		methods: {
      diakmodosithatjavaltozas: function() {
        this.axios.post(this.$store.state.backendeleres+"szilenciumibejegyzessablonok/"+this.$route.params.id+"/diakmodosithatja/"+(this.adatok.sablon.diakmodosithatja?0:1))
                  .then(response => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) this.adatok.sablon.diakmodosithatja=!this.adatok.sablon.diakmodosithatja;
                  })
      },
      hozzaadas: function() {
        var tanulok = (() => {
          switch(this.dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.valasztottlehetoseg) {
            case 0:
              return this.dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok1;
            break;
            case 1:
              return this.adatok.felhasznalok.filter(f=> f.minosites>=0&&this.dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok1.includes(f.csoportid)&&this.adatok.minositesek.find(m => m.id==f.minosites).szilenciumvalasztas==1).map(t => t.id)
            break;
            case 2:
              return this.adatok.felhasznalok.filter(f => f.minosites>=0&&this.adatok.minositesek.find(m => m.id==f.minosites).szilenciumvalasztas==1).map(t => t.id)
            break;
            case 3:
              return this.adatok.felhasznalok.filter(f => this.dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok1.includes(f.minosites)).map(t => t.id)
            break;
            case 13:
              return this.adatok.felhasznalok.filter(f => this.dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok2.includes(f.csoportid)&&this.dialogusok.bejegyzeshozzaadasa.diakokvalasztasa.kivalasztottszempontok1.includes(f.minosites)).map(t => t.id)
            break;
          }
        })().filter(t => this.adatok.sablonbejegyzesek.findIndex(sb => sb.tanuloid==t && sb.szilenciumid==this.dialogusok.bejegyzeshozzaadasa.adatok.szilencium)==-1).map(t => {
          return {
            tanuloid: t,
            szilenciumid: this.dialogusok.bejegyzeshozzaadasa.adatok.szilencium,
            teremid: this.dialogusok.bejegyzeshozzaadasa.adatok.terem
          }
        });
        this.axios.post(this.$store.state.backendeleres+"szilenciumibejegyzessablonok/"+this.$route.params.id+"/bejegyzeshozzaadasa", {bejegyzesek: tanulok}).then(response => {
          if(response.data.bejelentkezve==false) this.kijelentkezes();
          if(response.data.ok) {
            this.adatok.sablonbejegyzesek = response.data.sablonbejegyzesek;
            this.dialogusok.bejegyzeshozzaadasa.mutat=false;
            this.snackbar.szoveg="A hozzáadás sikeresen végbement."
            this.snackbar.mutat=true;
          }
          else {
            this.snackbar.szoveg="A hozzáadás hibába ütközött: "+response.data.hiba;
            this.snackbar.mutat=true;
          }
        })
      },
      torles: function() {
        this.axios.delete(this.$store.state.backendeleres+"szilenciumibejegyzessablonok/"+this.$route.params.id+"/"+this.dialogusok.torles.bejegyzes.bejegyzes.tanuloid+"/"+this.dialogusok.torles.bejegyzes.bejegyzes.szilenciumid)
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) {
                      this.adatok.sablonbejegyzesek.splice(this.adatok.sablonbejegyzesek.findIndex(sb => sb.tanuloid==this.dialogusok.torles.bejegyzes.bejegyzes.tanuloid&&sb.szilenciumid==this.dialogusok.torles.bejegyzes.bejegyzes.szilenciumid),1);
                      this.dialogusok.torles.mutat=false;
                      this.snackbar.szoveg="A törlés sikeresen végbement."
                      this.snackbar.mutat=true;
                    }
                    else {
                      this.snackbar.szoveg="A törlés hibába ütközött: "+response.data.hiba;
                      this.snackbar.mutat=true;
                    }
                  })
      },
      torlesdialogus: function(bejegyzes){
        this.dialogusok.torles.bejegyzes=bejegyzes
        if(this.dialogusok.torles.megerositesnelkul) this.torles();
        else this.dialogusok.torles.mutat=true;
      },
		},
		mounted(){
			this.axios.get(this.$store.state.backendeleres+"szilenciumibejegyzessablonok/"+this.$route.params.id).then((response) => {
				if(response.data.ok){
          this.adatok=response.data.adatok;
        }
        if(response.data.bejelentkezve== false) this.kijelentkezes();
			})
		}
	}
</script>
